import { AxiosResponse } from 'axios'

import ClientSDK from '../../App/ClientSDK'
import { transform } from './Transformer'
import { IApiSkinTrack } from './IApiSkinTrack'
import { ISkinTrack } from '../ISkinTrack'
import { Limb } from '../Limb'

class Client {
    static getSkinTrack = (customerUuid: string, limb: Limb): Promise<ISkinTrack> => {
        return ClientSDK.instance()
            .get(`customers/${customerUuid}/skin-tracks/${limb}`)
            .then((response: AxiosResponse<IApiSkinTrack>): ISkinTrack => transform(response.data))
    }

    static addMark = (
        skinTrackUuid: string,
        customerUuid: string,
        markId: number,
        fromLeft: number,
        fromTop: number,
        color: string
    ): AxiosResponse => {
        return ClientSDK.instance()
            .post(
                `customers/${customerUuid}/skin-tracks/${skinTrackUuid}/marks`,
                {
                    mark_id: markId,
                    from_left: fromLeft,
                    from_top: fromTop,
                    color
                }
            )
    }

    static deleteMark = (skinTrackUuid: string, customerUuid: string, markId: number): AxiosResponse => {
        return ClientSDK.instance()
            .delete(`customers/${customerUuid}/skin-tracks/${skinTrackUuid}/marks/${markId}`)
    }

    static moveMark = (
        skinTrackUuid: string,
        customerUuid: string,
        markId: number,
        fromLeft: number,
        fromTop: number
    ): AxiosResponse => {
        return ClientSDK.instance()
            .post(
                `customers/${customerUuid}/skin-tracks/${skinTrackUuid}/marks/${markId}/move`,
                { from_left: fromLeft, from_top: fromTop }
            )
    }

    static setNote = (
        skinTrackUuid: string,
        customerUuid: string,
        note: string,
    ): AxiosResponse => {
    return ClientSDK.instance()
        .post(
            `customers/${customerUuid}/skin-tracks/${skinTrackUuid}/note`,
            { note }
        )
    }
}

export default Client
